module.exports = __webpack_public_path__ + "media/trainstation.11d40296.svg";